const isForProd = process.env.REACT_APP_FOR === 'prod';

const prod = {
    parchi: 'https://parchi.eka.care',
    auth: 'https://auth.eka.care',
    agoraAppId: 'f1c7a40e1d4349888ff1b69714a3436c',
    tele: 'https://tele.eka.care',
    sentry: 'https://a961d684201d4dd290c1ed7cac10e299@o1128948.ingest.sentry.io/6681317',
    tryst: 'https://tryst.eka.care',
};

const staging = {
    parchi: 'https://parchi.dev.eka.care',
    auth: 'https://aorta.dev.eka.care',
    agoraAppId: 'a778e249134e4cd1b6560fcda3f290e4',
    tele: 'https://agota.dev.eka.care',
    sentry: '',
    tryst: 'https://tryst.dev.eka.care',
};

export const DOCS_APP_BE_URL = (isForProd ? prod : staging).parchi;
export const TRYST_HOST = (isForProd ? prod : staging).tryst;
export const AUTH_BASE_URL = (isForProd ? prod : staging).auth;
export const AGORA_APP_ID = (isForProd ? prod : staging).agoraAppId;
export const TELE_BE_URL = (isForProd ? prod : staging).tele;
export const SENTRY_DNS = (isForProd ? prod : staging).sentry;

export const GET_PAST_VITALS = `${DOCS_APP_BE_URL}/app/get/vitals`;
export const GET_PT_JOINING_URL_TELEV2 = (aid: string) =>
    `${TRYST_HOST}/get-guest-url-telev2?aid=${aid}`;
export const GET_POSTS_BY_DOC_ID = (docId: string): string =>
    `${DOCS_APP_BE_URL}/post/get/post-for-patient/${docId}`;
export const GET_POSTS_BY_ID = (postId: string): string =>
    `${DOCS_APP_BE_URL}/post/get/post/${postId}`;
export const GET_UHI_TELE_CONTEXT = (hash: string): string =>
    `${DOCS_APP_BE_URL}/service/uhi/get-context/${hash}`;

export const INIT_VIDEO_CALL = `${TELE_BE_URL}/v1/start/`;

export const GET_PATIENT_ADDRESS = (patient_oid: string): string =>
    `${DOCS_APP_BE_URL}/service/address/get?pid=${patient_oid}`;

export const AUTH_VERIFY = `${AUTH_BASE_URL}/auth/verify`;
export const SET_PATIENT_ADDRESS = `${DOCS_APP_BE_URL}/service/address/set`;

export const CONSENT_FORM = (id: string): string => `${DOCS_APP_BE_URL}/service/consent-form/${id}`;

export const PUSH_RENDER_PDF_TEMPLATE_IMAGE = (ptSign?: boolean): string =>
    `${DOCS_APP_BE_URL}/service/template/assets/upload${ptSign ? '?ptSign=true' : ''}`;
